// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDivCreate {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  width: 97%;
  margin-left: 20px;
  flex-shrink: 0;
  height: 872px;
  padding: 24px 32px 24px 32px;
}

.mainDivCreatenav {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  width: 97%;
  margin-left: 20px;
  margin-bottom: 40px;
  flex-shrink: 0;
  height: 100px;
  padding: 24px 32px 28px 32px;
}

.mainDivCreateform {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  width: 100%;
  margin-bottom: 40px;
  flex-shrink: 0;
  height: 500px;
  padding: 32px 32px 32px 32px;
}

.mainDivCreateform2 {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  width: 100%;
  flex-shrink: 0;
  height: 400px;
  padding: 32px 32px 32px 32px;
}
.titleCreate {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}

.fontCreate.MuiFormLabel-root.MuiInputLabel-root {
  font-weight: 400;
  height: 18px;
  font-size: 14px;
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
}

.textFieldCreate.MuiInputBase-root.MuiOutlinedInput-root {
  /* justify-content: contain; */
  width: 90%;
}
.MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {
  width: 120%;
}

.phone.MuiInputBase-root.MuiOutlinedInput-root {
  width: 20px !important;
  height: 40px;
}

.heightCreate.MuiInputBase-root.MuiOutlinedInput-root {
  height: 156px;
}

.iconStyleCreate {
  width: 24px;
  height: 24px;
}

.buttonCreate.MuiButtonBase-root.MuiButton-root {
  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
  display: flex;
  height: 45px;
  /* min-width: 60px; */
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  background: var(--generic-primary, #24b7aa);
  margin-left: 10px;
  margin-top: 28px;
}

.MuiButtonBase-root.MuiButton-root.buttonStyleCreate {
  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));

  /* Body/B2 Semi bold */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
}

.buttonDetails.MuiButtonBase-root.MuiButton-root {
  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
  display: flex;
  height: 45px;
  /* min-width: 60px; */
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  background: var(--generic-primary, #24b7aa);
}

.disableTextField.MuiInputBase-input.MuiOutlinedInput-input {
  width: 317px !important;
  padding: 11px 8px !important;
  background: white !important;
}

.phoneNumber.react-tel-input .form-control {
  width: 72%;
  height: 40px;
}

.buttonNotify.MuiButtonBase-root.MuiButton-root {
  display: inline-flex;
  height: 36px;
  width: 85px;
  padding: 0px 24px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--generic-primary, #24b7aa);
  align-self: end;
  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
}

.notifyText.MuiTypography-root {
  color: var(--text-medium, rgba(1, 1, 2, 0.6));

  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 116.667% */
  display: flex;
  align-items: center;
}

.PhoneInput .PhoneInput--focus {
  border: none !important;
  border-color: transparent !important;
  outline: none !important;
}

.PhoneInputInput {
  border: none !important;
}

.disabledPhoneNumber input {
  background: white;
  color: rgba(0, 0, 0, 0.38) !important;
}

.PhoneInputCountry {
  border-right: 1.4px solid var(--neutral-5, #cbcaca);
  padding: 4px;
}

.divider {
  border-top: 40px solid #ccc;
  margin: 20px 0;
}

.MuiPhoneNumber-underline:after {
  border-bottom: none;
  /* borderBottom: none,  */
}

.changePassowordModal .MuiPaper-root.MuiDialog-paper {
  width: 640px;
  border-radius: 16px;
  height: 388px;
}

.disabledColor .MuiTypography-root {
  opacity: 1;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.38);
}

.disabledColor .MuiInputAdornment-root {
  margin-right: 0px;
}

.enabledColor .MuiTypography-root {
  color: black !important;
}
.enabledColor .MuiInputAdornment-root {
  margin-right: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/adminProfile/adminProfile.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,WAAW;EACX,cAAc;EACd,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;;EAE7D,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,6DAA6D;EAC7D,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;;EAE7C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".mainDivCreate {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  width: 97%;\n  margin-left: 20px;\n  flex-shrink: 0;\n  height: 872px;\n  padding: 24px 32px 24px 32px;\n}\n\n.mainDivCreatenav {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  width: 97%;\n  margin-left: 20px;\n  margin-bottom: 40px;\n  flex-shrink: 0;\n  height: 100px;\n  padding: 24px 32px 28px 32px;\n}\n\n.mainDivCreateform {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  width: 100%;\n  margin-bottom: 40px;\n  flex-shrink: 0;\n  height: 500px;\n  padding: 32px 32px 32px 32px;\n}\n\n.mainDivCreateform2 {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  width: 100%;\n  flex-shrink: 0;\n  height: 400px;\n  padding: 32px 32px 32px 32px;\n}\n.titleCreate {\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.fontCreate.MuiFormLabel-root.MuiInputLabel-root {\n  font-weight: 400;\n  height: 18px;\n  font-size: 14px;\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n}\n\n.textFieldCreate.MuiInputBase-root.MuiOutlinedInput-root {\n  /* justify-content: contain; */\n  width: 90%;\n}\n.MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled {\n  width: 120%;\n}\n\n.phone.MuiInputBase-root.MuiOutlinedInput-root {\n  width: 20px !important;\n  height: 40px;\n}\n\n.heightCreate.MuiInputBase-root.MuiOutlinedInput-root {\n  height: 156px;\n}\n\n.iconStyleCreate {\n  width: 24px;\n  height: 24px;\n}\n\n.buttonCreate.MuiButtonBase-root.MuiButton-root {\n  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n  display: flex;\n  height: 45px;\n  /* min-width: 60px; */\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  background: var(--generic-primary, #24b7aa);\n  margin-left: 10px;\n  margin-top: 28px;\n}\n\n.MuiButtonBase-root.MuiButton-root.buttonStyleCreate {\n  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n\n  /* Body/B2 Semi bold */\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n}\n\n.buttonDetails.MuiButtonBase-root.MuiButton-root {\n  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n  display: flex;\n  height: 45px;\n  /* min-width: 60px; */\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  background: var(--generic-primary, #24b7aa);\n}\n\n.disableTextField.MuiInputBase-input.MuiOutlinedInput-input {\n  width: 317px !important;\n  padding: 11px 8px !important;\n  background: white !important;\n}\n\n.phoneNumber.react-tel-input .form-control {\n  width: 72%;\n  height: 40px;\n}\n\n.buttonNotify.MuiButtonBase-root.MuiButton-root {\n  display: inline-flex;\n  height: 36px;\n  width: 85px;\n  padding: 0px 24px;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  background: var(--generic-primary, #24b7aa);\n  align-self: end;\n  color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n}\n\n.notifyText.MuiTypography-root {\n  color: var(--text-medium, rgba(1, 1, 2, 0.6));\n\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px; /* 116.667% */\n  display: flex;\n  align-items: center;\n}\n\n.PhoneInput .PhoneInput--focus {\n  border: none !important;\n  border-color: transparent !important;\n  outline: none !important;\n}\n\n.PhoneInputInput {\n  border: none !important;\n}\n\n.disabledPhoneNumber input {\n  background: white;\n  color: rgba(0, 0, 0, 0.38) !important;\n}\n\n.PhoneInputCountry {\n  border-right: 1.4px solid var(--neutral-5, #cbcaca);\n  padding: 4px;\n}\n\n.divider {\n  border-top: 40px solid #ccc;\n  margin: 20px 0;\n}\n\n.MuiPhoneNumber-underline:after {\n  border-bottom: none;\n  /* borderBottom: none,  */\n}\n\n.changePassowordModal .MuiPaper-root.MuiDialog-paper {\n  width: 640px;\n  border-radius: 16px;\n  height: 388px;\n}\n\n.disabledColor .MuiTypography-root {\n  opacity: 1;\n  -webkit-text-fill-color: rgba(0, 0, 0, 0.38);\n}\n\n.disabledColor .MuiInputAdornment-root {\n  margin-right: 0px;\n}\n\n.enabledColor .MuiTypography-root {\n  color: black !important;\n}\n.enabledColor .MuiInputAdornment-root {\n  margin-right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
